<template>
	<svg version="1.1" v-bind:class="{turnOn: isTurnOn}"  id="Toaster" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		 viewBox="0 0 250 250" style="enable-background:new 0 0 250 250;" xml:space="preserve">
		<g>
			<g id="Button2" class="st0">
				<g class="st1">
					<rect x="205.2" y="153.1" class="st2" width="24.6" height="9.6"/>
				</g>
				<ellipse class="st3" cx="234.6" cy="158.7" rx="11.4" ry="11.9"/>
			</g>
			<g id="Bread" class="st0">
				<g class="st1">
					<rect x="70.5" y="53.1" class="st4" width="86.6" height="53.4"/>
					<path class="st4" d="M113.7,57.3c-1.3,7.5-14.4,11-23.3,11c-7.4,0-21.4-2.5-23.3-11c-1.4-6.5,5-12.9,6.2-14.1c7.1-7,16.4-6.3,19.4-5.9c8,1.1,13.1,6,14.7,7.8C110.1,47.8,114.5,52.5,113.7,57.3z"/>
					<path class="st4" d="M160.3,55.8c-1.3,7.5-14.4,11-23.3,11c-8.9,0-22.1-3.7-23.3-11c-1.3-8,11.9-18.9,24.3-18.8c8.2,0.1,14,4.9,15,5.8C154.8,44.4,161.3,50,160.3,55.8z"/>
					<rect x="71.2" y="51.6" class="st5" width="84.9" height="24.2"/>
				</g>
				<g class="st1">
					<rect x="73" y="64.4" class="st4" width="81.4" height="49.8"/>
					<path class="st4" d="M113.6,68.3c-1.2,7-13.5,10.3-21.9,10.3c-7,0-20.1-2.3-21.9-10.3c-1.4-6.1,4.7-12.1,5.8-13.2c6.6-6.6,15.4-5.9,18.3-5.5c7.6,1,12.3,5.6,13.8,7.2C110.2,59.4,114.4,63.8,113.6,68.3z"/>
					<path class="st4" d="M157.4,66.9c-1.2,7-13.6,10.3-21.9,10.3c-8.4,0-20.8-3.5-21.9-10.3c-1.3-7.4,11.1-17.6,22.9-17.5c7.7,0.1,13.1,4.6,14.1,5.4C152.3,56.2,158.4,61.5,157.4,66.9z"/>
					<rect x="73.7" y="63" class="st5" width="79.8" height="22.6"/>
				</g>
			</g>
			<g id="Button1">
				<g>
					<rect x="204.9" y="191" class="st2" width="24.6" height="9.6"/>
				</g>
				<ellipse class="st2" cx="234.3" cy="196.6" rx="11.4" ry="11.9"/>
			</g>
			<g id="Legs">
				<g>
					<path class="st6" d="M23.4,250c7.4,0,14.8,0,22.3,0c3.4-7.9,6.7-15.8,10.1-23.8H23.4V250z"/>
				</g>
				<g>
					<path class="st6" d="M198.3,250c-7.4,0-14.8,0-22.3,0c-3.4-7.9-6.7-15.8-10.1-23.8h32.4V250z"/>
				</g>
			</g>
			<g id="Body">
				<g>
					<path class="st7" d="M17.6,221.5c-4.5,0-8.1-3.8-8.1-8.5v-53.4c0.7-9,2.6-17.8,5.8-26.2c1.7-4.5,5.2-13.9,11.4-21.1C39,98,58.1,95.9,68.5,95.9c0.9,0,1.7,0,2.3,0l81.2,0c8.3,0,24.2,1.8,37.4,13.3c8.6,7.5,13.1,16.5,15.4,21.4c4.4,8.9,7.1,18.6,8.1,28.6V213c0,4.7-3.7,8.5-8.1,8.5H17.6z"/>
					<path class="st8" d="M68.5,97.9c0.7,0,1.5,0,2.2,0l0.1,0h0.1h81.1c8,0,23.3,1.7,36.1,12.8c8.3,7.2,12.5,15.7,15,20.8c4.3,8.7,6.9,18,7.8,27.9V213c0,3.6-2.8,6.5-6.1,6.5h-187c-3.4,0-6.1-2.9-6.1-6.5v-53.3c0.7-8.8,2.6-17.4,5.6-25.5c1.7-4.4,5.1-13.6,11.1-20.5C40,99.9,58.5,97.9,68.5,97.9 M68.5,93.9c-8.7,0-29.9,1.5-43.3,17.2c-6.4,7.5-10,17.1-11.8,21.7C9.3,143.4,8,153,7.5,159.5V213c0,5.8,4.5,10.5,10.1,10.5h187c5.6,0,10.1-4.7,10.1-10.5c0-18,0-35.9,0-53.9c-0.6-6.8-2.5-17.6-8.3-29.4c-2.7-5.5-7.2-14.4-15.9-22C176,95,158.8,93.9,151.9,93.9H70.8C70.2,93.9,69.4,93.9,68.5,93.9L68.5,93.9z"/>
				</g>
				<path class="st9" d="M203.1,231.3H19.2c-6.4,0-11.7-5.3-11.7-11.7v-0.9c0-6.4,5.3-11.7,11.7-11.7h183.8c6.4,0,11.7,5.3,11.7,11.7v0.9C214.8,226.1,209.5,231.3,203.1,231.3z"/>
			</g>
			<g id="Grid">
				<path class="st10" d="M165.6,96H61.6c-1.1,0-2-0.9-2-2v-0.2c0-1.1,0.9-2,2-2h104.1c1.1,0,2,0.9,2,2v0.2C167.7,95,166.7,96,165.6,96z"/>
				<path class="st10" d="M165.6,96h-4.9c-1.9,0-3.5-1.6-3.5-3.5v-4.6c0-1.9,1.6-3.5,3.5-3.5h0.7c4.2,0,7.6,3.4,7.6,7.6v0.4C169.1,94.4,167.5,96,165.6,96z"/>
				<path class="st10" d="M62.6,95.9h4.9c1.9,0,3.5-1.6,3.5-3.5v-4.6c0-1.9-1.6-3.5-3.5-3.5h-0.7c-4.2,0-7.6,3.4-7.6,7.6v0.4C59.1,94.3,60.6,95.9,62.6,95.9z"/>
			</g>
			<g id="Fire">
				<path class="st11" d="M113.7,27.7c2.8,5.8,2.8,10,2.3,12.8c-0.4,2.2-1.1,2.7-2.5,7.6c-1.2,4.2-1.8,6.2-1.9,8.9c0,2,0.2,5.3,2,9.4"/>
				<path class="st11" d="M87.6,37.7c2.8,5.2,2.8,8.9,2.4,11.5c-0.4,2-1,2.5-2.6,7.6c-1.2,3.8-1.8,5.7-2,7.8c-0.1,1.9,0,5.2,2,9.3"/>
				<path class="st11" d="M140,37.7c3,4.8,3.3,8.5,2.9,10.9c-0.4,2.5-1.2,2.8-3.1,8.3c-1.5,4.3-2.2,6.6-2.1,9.4c0.1,3.4,1.3,6.1,2.3,7.8"/>
			</g>
			<path id="Line" class="st12" d="M155.2,114.3H73.4c-1.1,0-2-0.9-2-2v-0.2c0-1.1,0.9-2,2-2h81.8c1.1,0,2,0.9,2,2v0.2C157.2,113.4,156.3,114.3,155.2,114.3z"/>
		</g>
	</svg>
</template>

<script>
    export default {
        name: "toaster",
		props:{
			isTurnOn: {
				type: Boolean,
				default: false,
			}
		}
    }
</script>

<style scoped lang="scss">
	/*Включено*/
	.turnOn{
		/*Хлеб, кнопка при включенном состоянии*/
		#Bread,#Button2{display: block !important;}
		/*Кнопка, огонечки при выключенном состоянии*/
		#Button1,#Fire{display: none !important;}
	}
    .st0{display:none;}
    .st1{display:inline;}
    .st2{fill:#363838;}
    .st3{display:inline;fill:#363838;}
    .st4{fill:#F4D387;stroke:#AA693C;stroke-width:5;stroke-miterlimit:10;}
    .st5{fill:#F4D387;}
    .st6{fill:#1D5151;}
    .st7{fill:#239BAF;}
    .st8{fill:#14808C;}
    .st9{fill:#246066;}
    .st10{fill:#344241;}
    .st11{fill:none;stroke:#991010;stroke-width:4;stroke-miterlimit:10;}
    .st12{fill:#E8DD1A;}
</style>